import React from 'react';

import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

export default function KeyStatTileSkeleton() {
    return (
        <SkeletonTheme borderRadius="0.5rem">
            <div className="tw-px-4 tw-py-3 tw-rounded-lg tw-border-2 tw-border-grey">
                <div>
                    <div className="tw-text-sm tw-text-blue-75 tw-font-medium mb-2">
                        <Skeleton height={20} width={70} />
                    </div>
                    <div className="tw-text-2.5xl tw-text-charcoal tw-font-semibold">
                        <Skeleton height={28} width={200} />
                    </div>
                </div>
            </div>
        </SkeletonTheme>
    );
}
